import request from '@/utils/request'

const prefix = '/web/v1/statistics'

export function bigScreen (data) {
  return request({
    url: prefix + '/big-screen',
    method: 'post',
    data
  })
}
